// extracted by mini-css-extract-plugin
export default {"PortentContainer":"Portent_PortentContainer__nvxeB","PortentText":"Portent_PortentText__Fch17"};